// extracted by mini-css-extract-plugin
export default {"container":"Navigation_container__b8nyq","link":"Navigation_link__8AzN8","icon":"Navigation_icon__0cAaJ"};